import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ServicesSection } from "@/components/ServicesSection";
import { AudioShowcase } from "@/components/AudioShowcase";
import { MerchSection } from "@/components/MerchSection";
import { BookingSection } from "@/components/BookingSection";
import { QuoteSection } from "@/components/QuoteSection";
import { FAQSection } from "@/components/FAQSection";

const useTitle = (title) => {
  useEffect(() => {
    document.title = `${title} | DGE: Cold-Blooded Records LLC™`;
    return () => { document.title = "DGE: Cold-Blooded Records LLC™ | Official ASCAP® Member Label — Est. 2026"; };
  }, [title]);
};

const PageShell = ({ children, testId }) => (
  <main className="bg-obsidian text-ice min-h-screen" data-testid={testId}>
    <Navbar />
    <div className="pt-[70px]">{children}</div>
    <Footer />
  </main>
);

export const useQuoteNav = () => {
  const navigate = useNavigate();
  return useCallback((service, details = "") => {
    const params = new URLSearchParams({ service });
    if (details) params.set("details", details);
    navigate(`/quote?${params.toString()}`);
  }, [navigate]);
};

export function ServicesPage() {
  useTitle("Services");
  const onQuote = useQuoteNav();
  return <PageShell testId="services-page"><ServicesSection onQuote={onQuote} /></PageShell>;
}

export function BeatsPage() {
  useTitle("Cold-Blooded Soundscapes™ — Beat Store");
  const onQuote = useQuoteNav();
  return <PageShell testId="beats-page"><AudioShowcase onQuote={onQuote} /></PageShell>;
}

export function MerchPage() {
  useTitle("Fan Merch");
  return <PageShell testId="merch-page"><MerchSection /></PageShell>;
}

export function BookingPage() {
  useTitle("Book a Session");
  return <PageShell testId="booking-page"><BookingSection /></PageShell>;
}

export function QuotePage() {
  useTitle("Request a Quote");
  return <PageShell testId="quote-page"><QuoteSection /></PageShell>;
}

export function FAQPage() {
  useTitle("FAQ");
  return <PageShell testId="faq-page"><FAQSection /></PageShell>;
}
